import { ViewModel,View, ObservableArray } from "binder"
import  { UserSessionLogsView } from "./userSessionLogs-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { ServerConnection } from "src/server/serverConnection";
import moment from "moment";

export class UserSessionLogsViewModel extends WindowViewModel{
    public getTitle(): string {
        return "سابقه ورود و خروج";
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.items = ObservableArray.create<singleUsage>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),150);
    }
    GetDefaultView(): View <ViewModel> {
        return new UserSessionLogsView();
    }
    public getTypeId(): string {
        return "VM-C36C64BD-B87C-44D4-AA04-B1DC07CDD93A"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set items(v: ObservableArray<singleUsage>) { this._items = v; } public get items(): ObservableArray<singleUsage> { return this._items;} private _items: ObservableArray<singleUsage>;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;

    refresh(){
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer("/Complex/SecurityRawDataServices/GetAllUserSessionLogs",{
                FurtherQueryInfo:filteringInformation
            });
            this.items.update(...result.Usages.map(x=>{
                let r = new singleUsage(this);
                r.username = x.Username;
                r.personnelName = x.PersonnelName;
                r.personnelLastName = x.PersonnelLastName;
                r.usedFrom = moment.utc(x.From);
                r.usedUntil = x.Until==null ? null :moment.utc(x.Until); 
                r.ip = x.Ip;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);

        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(1,1);
        } finally {
            this.isLoading = false;
        }
    }
}

export class singleUsage extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set username(v: string) { this._username = v; } public get username(): string { return this._username;} private _username: string;
    public set personnelName(v: string) { this._personnelName = v; } public get personnelName(): string { return this._personnelName;} private _personnelName: string;
    public set personnelLastName(v: string) { this._personnelLastName = v; } public get personnelLastName(): string { return this._personnelLastName;} private _personnelLastName: string;
    public set usedFrom(v: moment.Moment) { this._usedFrom = v; } public get usedFrom(): moment.Moment { return this._usedFrom;} private _usedFrom: moment.Moment;
    public set usedUntil(v: moment.Moment) { this._usedUntil = v; } public get usedUntil(): moment.Moment { return this._usedUntil;} private _usedUntil: moment.Moment;
    public set ip(v: string) { this._ip = v; } public get ip(): string { return this._ip;} private _ip: string;
    
}